module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"来店客数/坪"}}')
  delete Component.options._Ctor
}
